module.exports = __webpack_public_path__ + "static/media/mom.2273849a.jpg";